<template>
  <div class="image-gallery-section">
    <h3 class="gallery-title">
      <i class="gallery-icon">🖼️</i>
      项目图片与成果
    </h3>
    
    <div class="image-gallery">
      <div 
        v-for="(image, index) in images" 
        :key="index" 
        class="image-item"
      >
        <div class="image-container">
          <img 
            :src="image.src" 
            :alt="image.description" 
            class="gallery-image"
            loading="lazy"
          />
        </div>
        <p v-if="image.description" class="image-description">
          {{ image.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageGallery',
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.image-gallery-section {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid rgba(0, 64, 128, 0.1);
}

.gallery-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #004080;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.gallery-icon {
  font-size: 1.5rem;
}

.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.image-item {
  transition: all 0.3s ease;
}

.image-item:hover {
  transform: translateY(-5px);
}

.image-container {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  background: #f8f9fa;
}

.gallery-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.image-container:hover .gallery-image {
  transform: scale(1.05);
}

.image-description {
  padding: 1rem;
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
  text-align: center;
  background: white;
  border-radius: 0 0 12px 12px;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .image-gallery {
    grid-template-columns: 1fr;
  }
  
  .gallery-image {
    height: 250px;
  }
}
</style>